<template>
  <Modal>
    <Modal.Title>{{ title }}</Modal.Title>
    <Modal.Body>
      <div class="flex flex-col gap-4">
        <Input v-model="name" size="xl" :label="label" :disabled="loading" />
        <Alert v-if="error?.message" variant="error" :icon="AlertIcon">
          {{ error.message }}
        </Alert>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="!canSave"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, Alert, useModal } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'
import type { CopyrightOwnerNew } from '@/shared/graphql/legacy/generated'
import { useEditCopyrightOwner } from './useEditCopyrightOwner'

const { close } = useModal()

const props = defineProps<{
  owner: CopyrightOwnerNew
}>()

const { name, title, label, loading, error, canSave, save } =
  useEditCopyrightOwner(props.owner)

const handleSave = async () => {
  if (await save()) close()
}
</script>
